export default __webpack_public_path__ + "static/media/practice-test-4.057b69b3.csv";